<script>
import GeneratorMixin from '@/mixins/GeneratorMixin'
import BtnGenerator from '@/components/BtnGenerator.vue'
import SelectedChunks from './SelectedChunks.vue'

import wfList from "@/data/wf.json"
import disciplineList from "@/data/disciplines.json"

export default {
  data() {
    return {
      processedNum: 0,
      parents: []
    }
  },
  mixins: [GeneratorMixin],
  props: {
    selectedChunks: Object,
    sections: Array,
    processingChunks: Array,
    selectedChunksNum: Number,
    speciality: Object,
  },
  components: { BtnGenerator, SelectedChunks },
  emits: ['unselect-excluded', 'on-ok'],
  methods: {
    onOk() {
      this.$bvToast.toast(`Запущена фоновая генерация ТФ и дисциплин`, {
        ...this.commonToaster, variant: 'success'
      })
      this.$emit('on-ok')
      this.$bvModal.hide('modal-generate-headings')
    }
  },
  computed: {
    wfList() {
      return JSON.stringify(wfList[this.speciality.code].sort((a, b) => a[0].localeCompare(b[0])))
    },
    disciplineList() {
      return JSON.stringify(disciplineList[this.speciality.code].sort((a, b) => a.localeCompare(b)))
    },
    bgItems() {
      const res = {}
      for (const sectionIndex in this.selectedChunks) {
        for (const chunk of this.selectedChunks[sectionIndex]) {
          res[chunk.id] = chunk
        }
      }
      return res
    },
    busy() {
      return this.processedNum < this.selectedChunksNum
    }
  }
}
</script>

<template>
  <b-modal
      id="modal-set-wf-discipline"
      :busy="busy"
      centered
      lazy
      ok-title="Генерировать"
      scrollable
      size="lg"
      static
      title="Установить ТФ и дисциплины"
  >
    <selected-chunks :processing-chunks="processingChunks" :sections="sections" :selected-chunks="selectedChunks"/>

    <template #modal-footer>
      <b-btn variant="outline-secondary" @click="$emit('unselect-excluded')">
        Исключить исключенные
      </b-btn>
      <btn-generator
          :bg-items="bgItems"
          :callback="onOk"
          background
          btn-variant="outline-primary"
          :params="{speciality: speciality.name, wfList, disciplineList}"
          list-processing
          prompt-name="disciplineWF"
      />
    </template>
  </b-modal>
</template>

<style>
#modal-generate-headings .modal-content {
  min-height: 300px;
}
</style>